<template>
  <span
    class="tooltip"
    :tooltip="tooltipText"
    :flow="flow"
  >
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: 'Tooltip',
  props: {
    tooltipText: {
      type: String,
      required: true
    },
    flow: {
      type: String,
      default: 'down'
    }
  }
};
</script>

<style scoped>
.tooltip {
  position: relative;
  cursor: pointer;
}

.tooltip::before,
.tooltip::after {
  text-transform: none;
  font-size: 0.9em;
  line-height: 1;
  user-select: none;
  pointer-events: none;
  position: absolute;
  display: none;
  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip::before {
  content: '';
  border: 5px solid transparent;
  z-index: 1001;
}

.tooltip::after {
  content: attr(tooltip);
  font-family: Helvetica, sans-serif;
  text-align: center;
  min-width: 3em;
  max-width: 21em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 1ch 1.5ch;
  border-radius: 0.3ch;
  box-shadow: 0 1em 2em -0.5em rgba(0, 0, 0, 0.35);
  background: #333;
  color: #fff;
  z-index: 1000;
}

.tooltip:hover::before,
.tooltip:hover::after {
  display: block;
  opacity: 0.9;
}

.tooltip[flow^="down"]::before {
  top: 100%;
  border-top-width: 0;
  border-bottom-color: #333;
}

.tooltip[flow^="down"]::after {
  top: calc(100% + 5px);
}

.tooltip[flow^="down"]::before,
.tooltip[flow^="down"]::after {
  left: 50%;
  transform: translateX(-50%);
}


</style>